import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Stack, Typography, Link } from '@mui/material';
import Logo from './Logo';

interface MgeekFooterProps {
  /** 'dark': barra verde oscuro (landing). 'light': discreto para fondos claros (app). 'transparent': sobre degradados (login/registro). */
  variant?: 'dark' | 'light' | 'transparent';
}

/** Footer "Desarrollado por mgeek.cl", común a todo el sitio. */
const MgeekFooter: React.FC<MgeekFooterProps> = ({ variant = 'dark' }) => {
  const dark = variant === 'dark';
  const onColor = variant !== 'light';
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: dark ? '#075E54' : 'transparent',
        color: onColor ? 'white' : 'text.secondary',
        borderTop: variant === 'light' ? '1px solid #E2E8F0' : 'none',
        py: dark ? 4 : 2.5,
        width: '100%',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: dark ? 'row' : 'column' }}
          spacing={dark ? 2 : 0.5}
          alignItems="center"
          justifyContent="space-between"
        >
          {dark && <Logo size={30} tone="light" />}
          <Box sx={{ textAlign: { xs: 'center', md: dark ? 'right' : 'center' } }}>
            <Typography variant="body2">
              Desarrollado por{' '}
              <Link
                href="https://mgeek.cl"
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
                underline="always"
                sx={{ fontWeight: 600 }}
              >
                mgeek.cl
              </Link>
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              <Link component={RouterLink} to="/privacidad" color="inherit" underline="hover">Política de Privacidad</Link>
              {' · '}
              <Link component={RouterLink} to="/terminos" color="inherit" underline="hover">Condiciones del Servicio</Link>
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.85 }}>
              © {new Date().getFullYear()} mGeek. Todos los derechos reservados.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default MgeekFooter;
